import { injectable, postConstruct } from 'inversify'
import { IPost } from '@/model/post'
import { MetaService, MetaServiceImpl } from './MetaService'
import { SearchQuery } from '@/model/search/search-query'

export interface PostService extends MetaService<IPost> {
  fetchPosts(query: SearchQuery): Promise<IPost[]>
  addPost(post: IPost, tags: string[]): Promise<IPost>
}

@injectable()
export class PostServiceImpl extends MetaServiceImpl<IPost> implements PostService {
  @postConstruct()
  public initialize () {
  this.serviceName = 'posts'
  }

  public fetchPosts(query: SearchQuery): Promise<IPost[]> {
  return this.getApiService().search<IPost[]>('posts/search', { query: query })
  }

  public addPost(post: IPost, tags: string[]): Promise<IPost> {
  return this.getApiService().post<IPost>('posts', { 'post': post, 'tags': tags })
  }
}
